<template>
    <div class="row wrapper border-bottom white-bg page-heading">
        <div class="col-lg-10">
        <h2>{{ $t("navigations.source data verification summary") }}</h2>
        </div>
  </div>
  <div class="wrapper wrapper-content">
    <div class="ibox-content mb-1 px-3 py-2">
      <div class="form-group mb-1">
        <div class="d-flex flex-column flex-lg-row my-2 my-lg-0 mb-lg-0">
          <div class="form-group mb-lg-0 w-100 pl-lg-0 px-1">
            <label class="mb-0"> {{ $t("navigations.source") }}</label>
            <input
              type="text"
              v-model="searchData.Source"
              class="form-control my-md-2 my-lg-0"
            />
          </div>
          <div class="form-group mb-lg-0 w-100 pl-lg-0 px-1">
            <label class="mb-0"> {{ $t("navigations.assigned from") }}</label>
            <input
              type="date"
              v-model="searchData.FromDate"
              class="form-control my-md-2 my-lg-0"
            />
          </div>
          <div class="form-group mb-lg-0 w-100 pl-lg-0 px-1">
            <label class="mb-0"> {{ $t("navigations.assigned to") }}</label>
            <input
              type="date"
              v-model="searchData.ToDate"
              class="form-control my-md-2 my-lg-0"
            />
          </div>
          <div class="form-group mb-lg-0 w-100 pl-lg-0 px-1">
            <label class="mb-0"> {{ $t("navigations.status") }}</label>
            <select
              class="form-select my-md-2 my-lg-0"
              v-model="searchData.Status">
                <option value="">{{ $t("navigations.all") }}</option>
                <option value="Initiated">{{ $t("navigations.initiated") }}</option>
                <option value="In progress">{{ $t("navigations.in progress") }}</option>
                <option value="Completed">{{ $t("navigations.completed") }}</option>
            </select>
          </div>
          <span
            @click.prevent="search()"
            class="
              col-sm-12 col-lg-2 save_btn
              my-1 my-lg-0 mx-lg-1 align-self-end
            "
        >
            {{ $t("navigations.search") }}
          </span>
        </div>
      </div>
    </div>
    <div class="ibox-body">
     <div class="col-lg-12 tabbox px-0">
        <ul class="nav nav-tabs" role="tablist">
          <li>
            <a
              :class="{ activeTab: showBlock[0] === true }"
              @click="
                (showBlock[0] = true),
                  (showBlock[1] = false)
              "
              @click.prevent="selectDataSignalTab()"
              data-toggle="tab"
            >
              DataSignal SDV
            </a>
          </li>

          <li>
            <a
              :class="{ activeTab: showBlock[1] === true }"
              @click="
                (showBlock[1] = true),
                  (showBlock[0] = false)
              "
              @click.prevent="selectFormSdvTab()"
              data-toggle="tab"
              >Form SDV</a
            >
          </li>
        </ul>

      </div>
    <div v-if="showBlock[0]">
        <div class="ibox-title style_2 d-flex justify-content-between">
             <h5 class="mt-1 text-primary">DataSignal SDV List</h5>
        </div>
        <div class="ibox-content">
            <template v-if="showTableLoading === true">
                <div class="text-center" >
                    <img src="../../assets/img/loading.gif" width="15" alt="Waiting for login" />
                    <div> {{ $t("navigations.please wait while the list is being loaded") }} </div>
                </div>
            </template>
            <template v-else>
                 <div class="text-center" v-if="sdvList.Data.length === 0">
                    {{ $t('navigations.no data available') }}
                </div>
                 <div  v-else class="table-responsive">
                    <table class="table table-striped table-bordered dataTables">
                        <thead>
                          <tr>
                            <th>{{ $t("navigations.signalId") }}</th>
                            <th>{{ $t("navigations.source") }}</th>
                            <th>{{ $t("navigations.flagged as") }}</th>
                            <th>{{ $t("navigations.assigned by") }}</th>
                            <th>{{ $t("navigations.assigned date") }}</th>
                            <th>{{ $t("navigations.status") }}</th>
                            <th class="text-center">{{ $t("navigations.query") }}</th>
                             <th class="text-center">{{ $t("navigations.actions") }}</th>
                            <!-- <th class="text-center">{{ $t("navigations.do sdv") }}</th>
                            <th class="text-center">{{ $t("navigations.view") }}</th> -->
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="sdv in sdvList.Data" :key="sdv._id">
                            <td> {{ sdv.SignalId }} </td>
                            <td> {{ sdv.Source }} </td>
                            <td> {{ sdv.FlagType }} </td>
                            <td> {{ sdv.CreatedUserEmail }} </td>
                            <td> {{ filter(sdv.AssignedAt) }} </td>
                            <td> {{ sdv.Status }} </td>
                            <td  class="text-center">  
                              
                                
                                <i
                                @click="Openquerypopup(sdv._id)"
                                class="fa fa-question-circle edit-delete"
                                
                              ></i>
                              
                              
                            </td>
                            <!-- <td class="text-center">
                              <i
                                class="fa fa-arrow-circle-o-right edit-delete"
                                @click="openSDVModal(sdv._id, 'doSDV','dataSignal')"
                              ></i>
                            </td>
                            <td class="text-center">
                              <i
                                class="fa fa-eye edit-delete"
                                @click="openSDVModal(sdv._id, 'viewSDV','dataSignal')"
                              ></i>
                            </td> -->                           
                            <td class="align-items-center d-flex justify-content-center">
                            <button class="btn btn-sm btn-outline-secondary action-btn py-0 me-1" @click="openSDVModal(sdv._id, 'doSDV','dataSignal')">
                            <i class="fa fa-database"></i> Data
                            </button>
                            <button class="btn btn-sm btn-primary py-0 action-btn" @click="openSDVModal(sdv._id, 'viewSDV','dataSignal')">
                            <i class="fa fa-eye me-1"></i> View
                            </button>
                            </td>
                          </tr>
                        </tbody>
                    </table>
                 </div>
                 <div v-if="sdvList.Data.length != 0" class="row mt-1 mx-0">
                  <div class="col-lg-12 mx-0 px-0">
                    <div
                      class="
                        dataTables_paginate paging_simple_numbers
                        pagination  float-right "
                      >
                      <div class="col-lg-12 d-flex justify-content-lg-end px-0">
                        <v-pagination
                          v-model="currentPage"
                          :pages="totalPage"
                          :range-size="1"
                          active-color="#618bd7"
                          @update:modelValue="loadPage"
                        />
                      </div>
                    </div>
                  </div>
                 </div>
            </template>    
        </div>
        </div>
        <div v-if="showBlock[1]">
        <div class="ibox-title style_2 d-flex justify-content-between">
             <h5 class="mt-1 text-primary">Form SDV List</h5>
        </div>
        <div class="ibox-content">
           <div class="ibox-content">
            <template v-if="showTableLoading === true">
                <div class="text-center" >
                    <img src="../../assets/img/loading.gif" width="15" alt="Waiting for login" />
                    <div> {{ $t("navigations.please wait while the list is being loaded") }} </div>
                </div>
            </template>
            <template v-else>
                 <div class="text-center" v-if="formSdvList.entities.length === 0">
                    {{ $t('navigations.no data available') }}
                </div>
                 <div  v-else class="table-responsive">
                    <table class="table table-striped table-bordered dataTables">
                        <thead>
                          <tr>
                            <th>{{ $t("navigations.form") }}</th>
                            <th>{{ $t("navigations.source") }}</th>
                            <th>{{ $t("navigations.sdv level") }}</th>
                            <th>{{ $t("navigations.assigned by") }}</th>
                            <th>{{ $t("navigations.assigned date") }}</th>
                            <th>{{ $t("navigations.status") }}</th>
                            <th class="text-center">{{ $t("navigations.query") }}</th>
                            <th class="text-center">{{ $t("navigations.actions") }}</th>
                            <!-- <th class="text-center">{{ $t("navigations.do sdv") }}</th>
                            <th class="text-center">{{ $t("navigations.view") }}</th> -->
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="sdv in formSdvList.entities" :key="sdv.id">
                            <td> {{ sdv.templateName }} </td>
                            <td> {{ sdv.source }} </td>
                            <td> {{ sdv.sdvLevel }} </td>
                            <td> {{ sdv.CreatedUserEmail }} </td>
                            <td> {{ filter(sdv.assignedAt) }} </td>
                            <td> {{ sdv.status }} </td>
                            <td  class="text-center">  
                              
                                
                                <i
                                @click="Openquerypopup(sdv.id)"
                                class="fa fa-question-circle edit-delete"
                                
                              ></i>
                              
                              
                            </td>
                            <!-- <td class="text-center">
                              <i
                                class="fa fa-arrow-circle-o-right edit-delete"
                                @click="openSDVModal(sdv.id, 'doSDV','form')"
                              ></i>
                            </td>
                            <td class="text-center">
                              <i
                                class="fa fa-eye edit-delete"
                                @click="openSDVModal(sdv.id, 'viewSDV','form')"
                              ></i>
                            </td> -->
                            <td class="align-items-center d-flex justify-content-center">
                            <button class="btn btn-sm btn-outline-secondary action-btn py-0 me-1" @click="openSDVModal(sdv.id, 'doSDV','form')">
                            <i class="fa fa-database" ></i> Data
                            </button>
                            <button class="btn btn-sm btn-primary py-0 action-btn" @click="openSDVModal(sdv.id, 'viewSDV','form')">
                            <i class="fa fa-eye me-1"></i> View
                            </button>
                            </td>
                          </tr>
                        </tbody>
                    </table>
                 </div>
                 <div v-if="formSdvList.entities.length != 0" class="row mt-1 mx-0">
                  <div class="col-lg-12 mx-0 px-0">
                    <div
                      class="
                        dataTables_paginate paging_simple_numbers
                        pagination  float-right "
                      >
                      <div class="col-lg-12 d-flex justify-content-lg-end px-0">
                        <v-pagination
                          v-model="currentPage"
                          :pages="totalPage"
                          :range-size="1"
                          active-color="#618bd7"
                          @update:modelValue="loadPage"
                        />
                      </div>
                    </div>
                  </div>
                 </div>
            </template>    
        </div>
        </div>
        </div>
    </div>
  </div>
  <SDVModal
    v-if="showSDVModal"
    :id = "selectedId"
    :modalType = "selectedModalType"
    :fromTab ="selectedFromTab"
    @closeModal="closeSDVModal"
  />

  <ListSdvQueryModal
    v-if="showQueryModal"
    :signalid = "selectedId"
    @closeModal="closeQueryModal"
  />
</template>
 
<script src="./SDV_Summary.js"></script>
 
<style scoped>
.activeTab {
  color: #495057;
  background-color: #d2e6ef !important;
  border-color: #dee2e6 #dee2e6 #fff;
  border-radius: 5px 5px 0px 0px;
} 
.tabbox{
  background-color: #f3f3f4;
}
</style>